
import { styled } from "styletron-react";
import { colors, getGraphColor } from "./colors";
import { decors } from "./images";
import { mediaQueries } from "./mediaQueries";
import { HTMLAttributes } from "react";
import { FeedCurveComponent } from "../Services/Agrisys_GqlDataCaller/FeedDataCalls/GQLCalls/getFeedCurvesCall";

type Props = HTMLAttributes<HTMLDivElement>;

// A frame is a styling of an entire element, such as a div.

export const AbsoluteTopRight = styled("div", {
    position:"absolute",
    right:"0px",
    zIndex: "2"
});

// Def/Login flow Layout
export const Def = styled("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    zIndex: "1",
    position: "relative",
    height: "90vh"
});

export const DecorBg = styled("div", {
    backgroundImage: `url(${decors.def_bg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    width: "100vw",
    height: "100vh"
});

// #region | FullViewPanel Grid
// FullViewPanel Layout
const _gridTemplateAreas_fullViewPanel = `
  "logoDisplay page_outer page_outer"
  "globalMenu page_outer page_outer"
  "systemMenu page_outer page_outer"
  "statusBar statusBar languageSelector"
`;

const _gridTemplateAreas_fullViewPanel_mobile = `
  "page_outer"`;

export const FullViewPanel = styled("div", { 
    display: "Grid",
    gridTemplateColumns: "300px 1fr 370px",
    gridTemplateRows: "150px 350px 1fr 45px",
    gap: "5px",
    gridTemplateAreas: _gridTemplateAreas_fullViewPanel,
    padding: "20px",
    height: "100vh",
    boxSizing: "border-box",
    [mediaQueries.screenHeightMax]: {
        gridTemplateRows: "150px 190px 1fr 45px",
    },
    [mediaQueries.mobile]: {
      gridTemplateAreas: _gridTemplateAreas_fullViewPanel_mobile,
      gridTemplateColumns: "1fr",
      gridTemplateRows: "1fr",
      zIndex: "999",
  },
})

export const focus_viewPanel = styled("div", { 
  padding: "20px",
  height: "100dvh",
  boxSizing: "border-box",
  overflow: "hidden"
})

interface LogoDisplayProps {
  $focusView?: boolean
}
export const LogoDisplay = styled<"div", LogoDisplayProps>("div", (props) => ({
  backgroundColor: colors.greyDarkPrimary,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  width: props.$focusView ? "100%" : "300px",
  maxWidth: props.$focusView ? "555px" : undefined,
  height: props.$focusView ? "100%" : undefined,
  padding: props.$focusView ? "0px 25px" : undefined,
  boxSizing: props.$focusView ? "border-box" : undefined,
  [mediaQueries.mobile]: {
    width: "100%",
    maxWidth: "555px",
    height: "100%",
    margin: "0px auto",
    padding: "0px 25px",
    boxSizing: "border-box",
  }
}))
  
export const Menu_Outer = styled("div", {
  boxSizing: "border-box",
  display: "grid",
  gridTemplateColumns: "1fr",
  gridTemplateRows: "150px 1fr auto",
  rowGap: "10px",
  position: "relative",
  zIndex: "999999",
  padding: "10px",
  height: "100%",
  width: "100%"
})

interface Menu_InnerProps {
  $gridArea?: string
}

export const Menu_Inner = styled<"div", Menu_InnerProps>("div", (props) => ({
  gridArea: props.$gridArea,
  display: "flex",
  alignItems: "end",
  overflow: "hidden",
  maxHeight: "100%"
}))

export const GlobalMenu = styled("div", {
  backgroundColor: colors.greyDarkPrimary,
  borderWidth: "7.5px 1px",
  borderColor: colors.greyDarkPrimary,
  borderStyle: "solid",
  display: "flex",
  justifyContent: "center",
  boxSizing: "border-box",
  [mediaQueries.screenHeightMax]: {
    overflowY: "scroll",
    scrollbarColor: colors.greyDarkSecondary+colors.transparent,
    scrollbarWidth: "thin",
  },
  [mediaQueries.mobile]: {
    position: "relative",
    width: "100%",
    height: "fit-content",
    borderRadius: "10px 10px 0px 0px",
    margin: "0px auto",
    maxWidth: "555px"
  }
});

export const SystemMenu = styled("div", {
  padding: "0px 14px",
  backgroundColor: colors.greyDarkPrimary,
  borderWidth: "7.5px 1px",
  borderColor: colors.greyDarkPrimary,
  borderStyle: "solid",
  display: "flex",
  justifyContent: "center",
  overflowY: "auto",
  overflowX: "hidden",
  scrollbarColor: colors.greyDarkSecondary + colors.greyDarkPrimary,
  scrollbarWidth: "thin",
  boxSizing: "border-box",
  [mediaQueries.mobile]: {
    width: "100%",
    borderRadius: "10px 10px 0px 0px",
    margin: "0px auto",
    maxWidth: "555px",
  }
  
});

export const StatusBar = styled("div", {
  backgroundColor: colors.greyDarkPrimary,
  display: "flex",
  justifyContent: "start",
  alignItems: "center",
  flexDirection: "row",
  borderBottomLeftRadius: "10px",
  padding: "0 10px",
  gap: "10px"
});

export const TabMenu = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "start",
  flexDirection: "row",
  // [mediaQueries.mobile]: {
  //   position: "absolute"
  // }
})

export const CardsColumnCount = styled("div", {
    columnCount: "1",
    columnGap: "20px", 
    width: "100%",
    // width: "fit-content",
    // margin: "0 auto",
    [mediaQueries.columnCount2]: {
        columnCount: "2",
    },
    [mediaQueries.columnCount3]: {
        columnCount: "3",
    },
    [mediaQueries.columnCount4]: {
        columnCount: "4",
    }
})

// ---------------------------------------------------
// #endregion

// #region | Page Content
// Grid Page Outer containing TabMenu and Inner Page
const _gridTemplateAreas_page_outer = `
    "tabMenu"
    "inner_page"
`;
const _gridTemplateAreas_page_outer_mobile = `
    "inner_page"
`;
export const Page_outer = styled("div", {
    width: "100%",
  display: "Grid",
    gridArea: "page_outer",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "50px 1fr",
    gap: "5px",
    gridTemplateAreas: _gridTemplateAreas_page_outer,
    overflow: "hidden",
    height: "100%",
    [mediaQueries.mobileXs]: {
      gridTemplateAreas: _gridTemplateAreas_page_outer_mobile,
      gridTemplateRows: "1fr"
    }
})
export const _page_outer_tabMenu = styled("div", { 
    gridArea:"tabMenu", 
    overflowX: "scroll", 
    scrollbarWidth: "none", 
    overflowY: "hidden", 
    position: "relative", 
    [mediaQueries.mobileXs]: { 
      position: "absolute", 
      overflow: "visible", 
    }
})

interface _page_outer_inner_page_Props {
  $toolsMenu?: boolean;
}

export const _page_outer_inner_page = styled<"div", _page_outer_inner_page_Props>("div", (props) => ({
  gridArea:"inner_page", 
  overflow: "hidden", 
  padding: props.$toolsMenu ? "15px 0px 0px 15px" : "15px 0px 15px 15px", 
  [mediaQueries.mobile]: { 
    padding: "15px 0px 0px 0px" 
  }, 
  [mediaQueries.mobileXs]: { 
    padding: "0px" 
  },
}))

// Grid Page Inner fullView
const _gridTemplateAreas_page_inner = `
    "_page_inner_header"
    "_page_inner_content"
`;
export const Page_inner = styled("div", {
    // border: "1px dashed #aaa",
    height: "100%",
    display: "grid",
    gridAutoColumns: "1fr",
    gridAutoRows: "60px 1fr",
    gap: "10px",
    gridTemplateAreas: _gridTemplateAreas_page_inner
});
export const _page_inner_header = styled("div", {
    gridArea: "_page_inner_header",
    height: "100%"
});
export const _page_inner_content = styled("div", {
    gridArea: "_page_inner_content",
    overflow: "hidden",
    height: "100%"
});
export const _page_inner_content_scroll = styled("div", {
    gridArea: "_page_inner_content",
    overflowY: "auto",
    scrollbarColor: colors.greyDarkPrimary+colors.transparent,
    scrollbarWidth: "thin",
    height: "100%",
    gap: "10px",
    zIndex: "0"
});
// Grid Page Inner focus_view
export const Page_inner_focus_view = styled("div", {
  height: "100%",
  display: "grid",
  gridAutoColumns: "1fr",
  gridAutoRows: "30px 1fr",
  gap: "10px",
  gridTemplateAreas: _gridTemplateAreas_page_inner
});

export const Graph_QL_header = styled("div", {
  textAlign: "center",
});
export const Graph_QL_inner_content_scroll = styled("div", {
    gridArea: "_page_inner_content",
    overflowY: "auto",
    scrollbarColor: colors.greyDarkPrimary/*+colors.transparent*/,
    scrollbarWidth: "auto",
    height: "70vh",
    gap: "10px"
});
export const Graph_QL_sections = styled("div", {
margin: "20px",
"tr": {
paddingLeft: "10px",
},
p: {textAlign: "center"},
});
// ---------------------------------------------------
// #endregion

// #region | ToolsPanel Grid
// ToolsPanel Layout
const _gridTemplateAreas_toolsPanel = `
  "logoDisplay page_outer"
  "globalMenu page_outer"
  "systemMenu page_outer"
`;
const _gridTemplateAreas_toolsPanel_tablet = `
  "page_outer"`;
export const ToolsPanel = styled("div", { 
    display: "Grid",
    gridTemplateColumns: "300px 1fr",
    gridTemplateRows: "150px 180px 1fr",
    gap: "5px",
    gridTemplateAreas: _gridTemplateAreas_toolsPanel,
    padding: "20px",
    height: "100vh",
    boxSizing: "border-box",
    [mediaQueries.tablet]: {
        gridTemplateAreas: _gridTemplateAreas_toolsPanel_tablet,
        gridTemplateColumns: "1fr",
        gridTemplateRows: "1fr",
        zIndex: "0"
    }
})
// ToolsPanel Menu
export const ToolsSubMenu = styled("div", {
    backgroundColor: colors.greyDarkPrimary,
    padding: "7.5px 0px",
    alignItems: "start",
    borderRadius: "0 0 10px 10px",
    justifyContent: "center",
    display: "flex"
});

// backgroundColor: colors.greyDarkPrimary,
//   borderWidth: "7.5px 1px",
//   borderColor: colors.greyDarkPrimary,
//   borderStyle: "solid",
//   display: "flex",
//   justifyContent: "center",
//   boxSizing: "border-box",
//   [mediaQueries.screenHeightMax]: {
//     overflowY: "scroll",
//     scrollbarColor: colors.greyDarkSecondary+colors.transparent,
//     scrollbarWidth: "thin",
//   },
//   [mediaQueries.mobile]: {
//     position: "relative",
//     width: "100%",
//     height: "fit-content",
//     borderRadius: "10px 10px 0px 0px",
//     margin: "0px auto",
//     maxWidth: "555px"
//   }
// ---------------------------------------------------
// #endregion

// #region | Language Selector
// Frame for the language selector
export const LanguageNode = styled("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "95px",
    height: "45px",
    margin: "0 20px",
});
// Frame for the language selector and clock
export const DateTimeLang = styled("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 10px 0 30px",
    borderTopRightRadius: "10px", 
    borderBottomRightRadius: "10px",
});
// Frame for the language selector to handle tablet
export const LanguageSelector = styled("div", {
    gridArea: "languageSelector",
    backgroundColor: colors.greyDarkPrimary,
    borderRadius: "0px 10px 10px 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    [mediaQueries.tablet]: {
        gridArea: "none",
        position: "absolute",
        bottom: "20px",
        right: "20px",
        width: "280px",
        zIndex: "999"
    }
});
// ---------------------------------------------------
// #endregion

// #region | Table Grids
// Grid One Row
const _gridTemplateAreas_table_oneRow = `
    "grid_oneRow_top"
    "grid_oneRow_content"
`;
export const Grid_oneRow = styled("div", {
    width: "100%", 
    height: "100%", 
    display: "grid",
    gridAutoColumns: "1fr",
    gridAutoRows: "auto 1fr", // Auto for responsiveness
    gridTemplateAreas: _gridTemplateAreas_table_oneRow,
});
export const _grid_oneRow_top = styled("div", {
    gridArea: "grid_oneRow_top", 
    backgroundColor: colors.greyPrimary, 
    borderRadius: "10px 10px 0px 0px", 
    display: "flex", 
    flexDirection: "row", 
    alignItems: "center", 
    justifyContent: "space-between", 
    gap: "10px", 
    padding: "10px",
    minHeight: "35px"
}) as React.FC<Props>;

export const _grid_topBtns_outer = styled("div", {
  height: "100%",
  width: "100%",
  display: "grid",
  gridAutoRows: "50px calc(100% - 50px)",
  zIndex: "2",
  position: "relative"
})

export const _grid_topBtns_inner = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "end",
  padding: "0px 20px"
})

export const _grid_top_toggleBox_container = styled("div", {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  rowGap: "10px",
  flexWrap: "wrap"
}) as React.FC<Props>;

export const _grid_bluePrintButton_container = styled("div", {
  position: "absolute",
  bottom: "0px",
  left: "4px",
  zIndex: 99,
  width: "fit-content",
  height: "fit-content",
  cursor: "grab",
  transform: "rotate(90deg)",
  transformOrigin: "left bottom",
});

export const _grid_oneRow_content = styled("div", {
  gridArea: "grid_oneRow_content", 
  border: "5px solid", 
  borderColor: colors.greyPrimary, 
  borderTop: "none", 
  borderRadius: "0 0 10px 10px", 
  backgroundColor: colors.greyLightTertiary, 
  overflowY: "scroll", 
  scrollbarColor: " #D9D9D9 #D9D9D950", 
  scrollbarWidth: "thin", 
  gap: "30px",
  padding: "20px",
  flexWrap: "wrap",
  position: "relative",
  display: "flex",
});

// Grid Two Rows
const _gridTemplateAreas_table_twoRows = `
    "grid_twoRows_top_left grid_twoRows_top_right"
    "grid_twoRows_content_left grid_twoRows_content_right"
`;
export const Grid_twoRows = styled("div", {
    width: "100%", 
    height: "100%", 
    display: "grid",
    gridAutoColumns: "3fr 1fr",
    gridAutoRows: "auto 1fr", // Auto for responsiveness
    gap: "0 10px",
    gridTemplateAreas: _gridTemplateAreas_table_twoRows,
});
export const _grid_twoRows_top_left = styled("div", {
    gridArea: "grid_twoRows_top_left",
    borderRadius: "10px 0 0 0", 
});
export const _grid_twoRows_top_right = styled("div", {
    gridArea: "grid_twoRows_top_right",
    borderRadius: "0 10px 0 0", 
});
export const _grid_twoRows_content_left = styled("div", {
    gridArea: "grid_twoRows_content_left", 
    borderRight: "none !important", 
    borderRadius: "0 0 0 10px", 
});
export const _grid_twoRows_content_right = styled("div", {
    gridArea: "grid_twoRows_content_right",
    borderLeft: "none !important", 
    borderRadius: "0 0 10px 0", 
});


export const GraphQLTables = styled("div", {
    
    textAlign: "left",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& table": {
      width: "100%",
      border: "3px solid" ,
      borderColor: colors.greySecondary,
      borderRadius: "5px",
    },
    "& table tr:nth-child(odd)": {
      backgroundColor: "#D9D9D9",
    }
});

export const GraphQLTableLong = styled("div", {
  width: "75%",
});

// ---------------------------------------------------
// #endregion

// Logbook
export const LogBook = styled("div", {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%"
});

// AutoPig
export const AutoPig = styled("div", {
    display: "flex",
    justifyContent: "center"
});

interface PenItemProps {
  $hoveractive?: boolean;
}

export const PenItem = styled<"div", PenItemProps>("div", (props) => ({
  width: "695px",
  display: "grid",
  gridTemplateColumns: "55px 109px 521px",
  gap: "5px",
  padding: "0px 20px",
  backgroundColor: colors.greyLightSecondary,
  transition: "background-color 0.3s ease",
  ":hover": {
    backgroundColor: props.$hoveractive ? colors.greyLightPrimary : undefined,
    cursor: props.$hoveractive ? "pointer" : undefined
  },
}));

export const _grid_section_frame = styled<"div", PenItemProps>("div", (props) => ({
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "10px",
  width: "fit-content",
  height: "fit-content",
  padding: "10px 12px 14px 12px",
  position: "relative",
  opacity: "1",
  transition: "opacity 0.3s ease",
  ":hover": {
    opacity: props.$hoveractive ? "0.3" : undefined,
    cursor: props.$hoveractive ? "pointer" : undefined
  },
}))

interface LabelProps {
  $component?: FeedCurveComponent;
  $isHovered?: boolean;
  $textLabel?: boolean;
}

export const Label = styled<"div", LabelProps>("div", (props) => ({
  transition: "0.3s",
  backgroundColor: props.$textLabel ? undefined :
  props.$isHovered ? colors.greyTertiary : props.$component ? getGraphColor(props.$component.componentId) : colors.greyPrimary, 
  color: props.$textLabel ? props.$isHovered ? colors.greyTertiary : colors.greyDarkPrimary : colors.whitePrimary,
  borderRadius: "6px",
  width: "fit-content",
  cursor: "default",
  padding: props.$component ? "4px 8px" : undefined,
  whiteSpace: "nowrap",
  fontSize: "12px",  // fonts.fontSize 4
  // fonts.header
  fontFamily: "Inter Flex",
  height: props.$component ? undefined : "15px", 
  margin: "0px",
  textTransform: "uppercase",
  fontWeight: "500",
  //
  // hover when component is hovered or triggerHover from another component is true
  ":hover": props.$isHovered === undefined ? {} : {
    backgroundColor: props.$textLabel ? undefined : colors.greyTertiary,
    color: props.$textLabel ? colors.greyTertiary : undefined
  }
  //
}));

interface LfPenProps {
  $selectable?: boolean;
  $isSelected?: boolean;
  $gridArea: string
}

export const LfPen = styled<"div", LfPenProps>("div", (props) => ({
  width: "80px",
  height: "30px",
  textAlign: "center",
  alignContent: "center",
  boxSizing: "border-box",
  padding: "0px 10px",
  transition: "filter 0.3s",
  filter: props.$selectable&& !props.$isSelected ? "opacity(0.5)" : "opacity(1)",
  color: colors.greyDarkPrimary,
  zIndex: "99999",
  cursor: "pointer",
  position: "relative",
  gridArea: props.$gridArea,
  backgroundColor: colors.greyLightSecondary,
  pointerEvents: props.$selectable ? "all" : "none",
  ":hover": {
    filter: props.$selectable ? "opacity(0.5)" : undefined,
  },
}))